<template>
  <div class="content">
      <div class="row">
          <div class="col-md-12">
              <a-card>

                  <form @submit.prevent="addData($event)">
                      <div class="row">
                          <div class="col-md-4 my-1">
                              <div class="form-group ">
                                  <label>نام</label>
                                  <input type="text" name="title" v-model="info.title" class="form-control" />
                              </div>
                          </div>
                          <div class="col-md-4 my-1">
                              <div class="form-group ">
                                  <label>آدرس url </label>
                                  <input type="text" name="url" v-model="info.url" class="form-control" />
                              </div>
                          </div>

                          <div class="col-md-4 my-1">
                              <div class="form-group ">
                                  <label class="sr-only" for="inline-form-input-name"> دسته اصلی</label>
                                  <select name="parent_id" class="form-control" v-model="info.parent_id">
                                      <option value="">انتخاب</option>
                                      <option v-for="parent in parents" :value="parent.id">{{ parent . title }}
                                      </option>

                                  </select>
                              </div>
                          </div>
 <div class="col-md-4 my-1">
                                <div class="form-group ">
                                    <label>درصد کارمزد</label>
                                    <input type="number" name="wage_percent" v-model="info.wage_percent" class="form-control" />
                                </div>
                            </div>
                          <div class="col-md-12 my-5">
                              <div class="form-group ">
                                  <label>توضیحات</label>
                                  <b-form-textarea name="description" id="textarea" v-model="info.description" placeholder="توضیحات ..."
                                      rows="3" max-rows="6"></b-form-textarea>
                              </div>

                          </div>

                          <hr class="mt-5">


                          


                      </div>
                      <div class="card-footer  ">
                          <div class="row ">
                              <div class="col-md-10"></div>
                              <div class="col-md-1 ">
                                  <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                      ذخیره
                                  </button>
                              </div>
                             
                              <div class="col-md-1 ">
                                  <router-link to="/categories/list" class="btn btn-fill btn-outline-danger w-100">
                                      بازگشت</router-link>
                              </div>

                          </div>

                      </div>
                  </form>
              </a-card>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
      data() {
          return {
              info: {
              },
              parents:[]
            
          };
      },
      mounted() {
          this.getAll();
          let _this = this;
          axios
                .get("/categories/single/" + this.$route.params.id)
                .then(function(response) {
                    console.log(response)
                    _this.info = response.data;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
      },
      methods: {
          async getAll() {
              let _this = this;
              let url = '/categories/all';
              await axios
                  .get(url)
                  .then(function(response) {
                      _this.parents = response.data.data;
                  })
                  .catch(function(err) {
                      _this.$root.handleAxiosError(err);
                  });
          },
          addData(event) {
              let _this = this;
              let data = new FormData(event.target);
              data.append("status", 1);
              _this.$root.loading = true;

              axios
                  .post("/categories/edit/"+ this.$route.params.id, data)
                  .then(function(response) {
                      _this.$root.loading = false;
                      _this.$toast.success("دسته بندی با موفقیت ذخیره شد");
                      _this.$router.push("/categories/list");
                  })
                  .catch(function(err) {
                      _this.$root.loading = false;
                      _this.$root.handleAxiosError(err);
                  });
          },
      },
  };
</script>
